(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ki-audience-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ki-audience-slider')) {
    customElements.define(
      'ki-audience-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          if (!this.track) return;

          this.prev?.addEventListener('click', () => this.scrollByCard(-1));
          this.next?.addEventListener('click', () => this.scrollByCard(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          window.addEventListener('resize', this.onResize = () => this.update());
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.onResize);
        }

        scrollByCard(direction) {
          const card = this.track.querySelector('li');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ki-header-menu')) {
    customElements.define(
      'ki-header-menu',
      class extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('[data-toggle]');
          this.toggle?.addEventListener('click', () => this.setOpen(!this.hasAttribute('data-open')));
          this.querySelectorAll('[data-panel] a').forEach((link) =>
            link.addEventListener('click', () => this.setOpen(false))
          );
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.hasAttribute('data-open')) {
              this.setOpen(false);
              this.toggle?.focus();
            }
          });
        }

        setOpen(open) {
          this.toggleAttribute('data-open', open);
          this.toggle?.setAttribute('aria-expanded', String(open));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
